<template>
  <div class="q-gutter-sm q-pa-lg" style="background-color: #f1f2f7;">
    <div class="row">
      <div class="col-12 q-mb-md right">
        <h4 class="q-ma-none">List of Employee Schedules</h4><br />
        <div class="row">
          <!-- <div class="row justify q-banner--top-padding">
            <q-btn style="margin-right: 10px;" color="green" label="Add schedule" @click="downloadModal"
              v-show="canExport"></q-btn>
          </div> -->
          <!-- <div class="row justify-end q-carousel__navigation-inner">
            <q-select v-model="location" :options="locationOptions" label="LOCATION" @input="getEmployees"
              style="width: 200px" tabindex="0" />
            <q-select v-model="department" :options="departments" option-value="id" option-label="name" emit-value
              map-options label="DEPARTMENT" @input="getEmployees" style="width: 200px" />
          </div> -->
        </div>
      </div>
      <div class="col-12 q-mb-md">
        <div class="col-12 q-mb-md">
          <q-table class="my-sticky-column-table" :dense="$q.screen.lt.md" :grid="$q.screen.xs" title="Employees"
            :data="employees" :columns="columns" row-key="id" separator="cell"
            no-data-label="I didn't find anything for you!" :pagination.sync="pagination" :loading="loading"
            :filter="filter" @request="onRequest" binary-state-sort>
            <template v-slot:body="props">
              <q-tr slot="body" :props="props">
                <q-td key="photo" :props="props">
                  <q-avatar>
                    <img :src="apiUrl + props.row.image" onerror="../../assets/boy-avatar.png">
                  </q-avatar>
                </q-td>
                <q-td key="name" :props="props">{{ props.row.firstname }} {{ props.row.middlename }} {{ props.row.lastname }}</q-td>
                <q-td v-for="day in ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']" :key="day" :props="props">
                  <q-btn unelevated rounded :label="props.row[day] || 'No Schedule'"
                     style="background-color: #e8e8ea;" @click="editSchedule(props.row, day); currentEmployee = `${props.row.firstname} ${props.row.lastname}`" />
                </q-td>

              </q-tr>
            </template>
            <template v-slot:no-data="">
              <div class="full-width row flex-center text-red q-gutter-sm">
                <i class="fas fa-exclamation-triangle"></i>
                <span>The filter didn't uncover any results!</span>
              </div>
            </template>
            <template v-slot:loading>
              <q-inner-loading showing>
                <q-spinner-hourglass size="50px" color="cyan" />
              </q-inner-loading>
            </template>
            <template v-slot:top-right="props">
              <q-input dense v-model="filter" placeholder="Search Employee">
                <i class="fas fa-search" slot="append"></i>
              </q-input>
            </template>
          </q-table>
          <q-dialog v-model="spinner" persistent>
            <q-card class="my-card transparent no-shadow">
              <q-card-section>
                <q-spinner-gears color="cyan" size="5.5em" />
              </q-card-section>
            </q-card>
          </q-dialog>
        </div>
        <!-- ruben::29/08/2023 start -->
        <q-dialog v-model="importAccountDialog" persistent transition-show="scale" transition-hide="scale">
          <q-card class="q-bottom-sheet--list">
            <q-form ref="form" autocomplete="off" @submit="onSubmit">
              <q-card-section>
                <div class="text-h6">Select Bank Template File</div>
              </q-card-section>
              <q-card-section>
                <input type="file" id="file" ref="file"
                  :rules="[val => val && val.length > 0 || 'This field is required!']" v-on:change="handleFileUpload()"
                  required />

              </q-card-section>
              <q-card-actions align="right">
                <div>
                  <q-btn flat label="Submit" type="submit" color="primary" />
                  <q-btn flat label="Close" color="primary" @click="closeModal" />
                </div>
              </q-card-actions>
            </q-form>
          </q-card>
        </q-dialog>
        <!-- Schedule Edit Dialog -->
        <q-dialog v-model="scheduleDialog">
          <q-card style="max-width: 580px;">
            <q-card-section class="row items-center q-pb-none">
              <div class="text-h6">Edit {{currentEmployee}}'s {{ selectedDay }} Schedule</div>
              <q-space />
              <q-btn label="Close" flat round dense v-close-popup />
            </q-card-section>
            <q-card-section>
              <div class="q-gutter-md">
                <div class="row q-col-gutter-md">
                  <div class="col-6">
                    <q-time v-model="scheduleForm.startTime" title="Start Time" format24h />
                  </div>
                  <div class="col-6">
                    <q-time v-model="scheduleForm.endTime" title="End Time" format24h />
                  </div>
                </div>
              </div>
            </q-card-section>
            <q-card-actions align="right">
              <q-btn flat label="Delete" color="negative" @click="deleteSchedule" v-if="selectedEmployee && selectedEmployee[selectedDay]" />
              <q-space />
              <q-btn flat label="Save" color="primary" :disabled="disableButton" @click="saveSchedule" />
            </q-card-actions>
          </q-card>
        </q-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  name: 'ListEmployee',
  data() {
    return {
      filter: '',
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 15,
        rowsNumber: 10
      },

      canDownload: false,
      canImport: false,
      canExport: false,
      canEdit: false,
      canUpdateCareer: false,
      canMBF: false,
      canMerits: false,

      canDownloadValue: 1,
      canImportValue: 2,
      canEmportValue: 3,
      canEditValue: 4,
      canUpdateCareerValue: 5,
      canMBFValue: 6,
      canMeritsValue: 7,

      exportModaL: false,
      importfile: false,
      template: null,
      status: 'ALL',
      department: 0,
      location: 'ALL',
      spinner: false,

      columns: [
        { name: 'photo', align: 'left', label: 'Photo', field: '', sortable: true },
        { name: 'name', align: 'center', label: 'First Name', field: 'firstname', sortable: true },
        { name: 'monday', align: 'center', label: 'Monday', field: 'monday', sortable: true },
        { name: 'tuesday', align: 'center', label: 'Tuesday', field: 'tuesday', sortable: true },
        { name: 'wednesday', align: 'center', label: 'Wednesday', field: 'wednesday', sortable: true },
        { name: 'thursday', align: 'center', label: 'Thursday', field: 'thursday', sortable: true },
        { name: 'friday', align: 'center', label: 'Friday', field: 'friday', sortable: true },
        { name: 'saturday', align: 'center', label: 'Saturday', field: 'saturday', sortable: true },
      ],
      locationOptions: [],
      employees: [],
      statuses: [],
      departments: [],
      currentWeekDates: [],
      scheduleDialog: false,
      selectedEmployee: null,
      selectedDay: null,
      scheduleForm: {
        shiftTime: '',
        startTime: null,
        endTime: null,
      },
      disableButton: false,
      currentEmployee: null,
      apiUrl: process.env.VUE_APP_API_URL,
    }

  },

  created() {
    this.getWeekDates()
    this.getDropdownProperties()
    this.getEmployees()
    this.autoHoldEmployee()
    this.autoCareerUpdate()
    this.eventHub.$on('refreshEmployeeList', this.getEmployees);
    this.getMyPermission()

  },


  methods: {
    // ================================================
    // Get current week dates
    // ================================================
    getWeekDates() {
      const today = new Date();
      const currentDay = today.getDay();
      const diff = today.getDate() - currentDay + (currentDay === 0 ? -6 : 1); // Get Monday
      const monday = new Date(today.setDate(diff));
      
      this.currentWeekDates = [];
      const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      
      for (let i = 0; i < 6; i++) {
        const date = new Date(monday);
        date.setDate(date.getDate() + i);
        this.currentWeekDates.push(date.getDate());
      }
      
      // Update columns with dates
      this.columns = [
        { name: 'photo', align: 'left', label: 'Photo', field: '', sortable: true },
        { name: 'name', align: 'center', label: 'First Name', field: 'firstname', sortable: true },
        { name: 'monday', align: 'center', label: `Monday ${this.currentWeekDates[0]}`, field: 'monday', sortable: true },
        { name: 'tuesday', align: 'center', label: `Tuesday ${this.currentWeekDates[1]}`, field: 'tuesday', sortable: true },
        { name: 'wednesday', align: 'center', label: `Wednesday ${this.currentWeekDates[2]}`, field: 'wednesday', sortable: true },
        { name: 'thursday', align: 'center', label: `Thursday ${this.currentWeekDates[3]}`, field: 'thursday', sortable: true },
        { name: 'friday', align: 'center', label: `Friday ${this.currentWeekDates[4]}`, field: 'friday', sortable: true },
        { name: 'saturday', align: 'center', label: `Saturday ${this.currentWeekDates[5]}`, field: 'saturday', sortable: true },
      ];
    },

    // ================================================
    // ruben::29/08/2023 start
    // ================================================

    importAccount() {
      this.importAccountDialog = true
    },

    onSubmit: function () {
      this.spinner = true
      let formData = new FormData();
      formData.append("files", this.file);
      axios({
        // onUploadProgress: uploadEvent => {
        //   console.log("Progress: " + Math.round(uploadEvent.loaded / uploadEvent.total * 100) + '%')
        // },
        headers: { 'Authorization': `Bearer ${this.token}` },
        url: this.apiUrl + '/employee/import-account',
        data: formData,
        method: 'POST'
      }).then(response => {
        console.log(this.token)
        console.log('tes', response)

        setTimeout(() => {
          this.spinner = false
          this.importfile = false
        }, 500)
        // this.eventHub.$emit('refreshEmployeeList');
        this.$q.notify({
          message: 'Successful',
          color: 'green',
          position: 'center',
          actions: [
            { label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
          ]
        })
      }).catch((error) => {
        var message = error.response.data.exception[1].message
        var index = message.indexOf("1062");
        var final = message.substring(index + 4);
        this.$q.notify({
          message: final,
          color: 'negative',
          position: 'center',
          actions: [
            { label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
          ]
        })
        this.spinner = false
      })
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },

    closeModal: function () {
      this.importAccountDialog = false
    },
    // ==============================================================
    // ruben::29/08/2023 end
    // ==============================================================

    //start if server side
    onRequest(props) {

      const { page, rowsPerPage } = props.pagination


      const filter = props.filter
      this.loading = true
      setTimeout(() => {
        this.getRowsNumberCount(filter).then(total => {
          this.pagination.rowsNumber = total
        })
        const fetchCount = rowsPerPage === 0 ? this.pagination.rowsNumber : rowsPerPage
        const startRow = (page - 1) * rowsPerPage
        this.fetchFromServer(startRow, fetchCount, filter)
        this.pagination.page = page
        this.pagination.rowsPerPage = rowsPerPage
      }, 1500)
    },

    fetchFromServer(startRow, count, filter) {
      axios.get(this.apiUrl + '/employees', {
        headers: { 'Authorization': `Bearer ${this.token}` },
        params: {
          status: 'ACTIVE',
          location: this.location,
          department: this.department,
          roleID: this.userData.role_id,
          start: startRow,
          countPerPage: count,
          filter: filter,
        }
      }).then((response) => {
        this.employees = response.data.data
        // Load schedules for each employee
        this.loadSchedulesForEmployees()
        this.loading = false
      }).catch((error) => {
        console.log(error);
      })
    },

    loadSchedulesForEmployees() {
      this.employees.forEach((employee) => {
        axios.get(this.apiUrl + '/employee/schedule', {
          headers: { 'Authorization': `Bearer ${this.token}` },
          params: {
            employee_id: employee.id,
          }
        }).then((response) => {
          if (response.data.status && response.data.data) {
            // Use $set to ensure Vue reactivity for each day
            Object.keys(response.data.data).forEach((day) => {
              this.$set(employee, day, response.data.data[day]);
            });
          }
        }).catch((error) => {
          console.log('Error loading schedules for employee', employee.id, ':', error);
        });
      });
    },

    async getRowsNumberCount(filter) {
      console.log(this.department)
      let response = await axios.get(this.apiUrl + '/employees/total', {
        headers: { 'Authorization': `Bearer ${this.token}` },
        params: {
          status: 'ACTIVE',
          location: this.location,
          department: this.department,
          roleID: this.userData.role_id,
          filter: filter,
        }
      })
      return response.data
    },

    ///end of server side

    getEmployees: function () {
      this.onRequest({ pagination: this.pagination, filter: '' })
    },

    selectedRow(emp) {
      this.eventHub.$emit('EditEmployee', { stat: true, employee: emp });
    },

    careerUpdate(emp) {
      this.eventHub.$emit('CareerUpdates', { stat: true, employee: emp });
    },

    MBFUpdate(emp) {
      this.eventHub.$emit('MBFUpdate', { stat: true, employee: emp });
    },

    meritsUpdate(emp) {
      this.eventHub.$emit('meritsUpdate', { stat: true, employee: emp });
    },


    downloadTemplate: function (url, filename) {
      axios({
        url: this.apiUrl + '/' + url,
        headers: {
          'Authorization': `Bearer ${this.token}`
        },
        method: 'GET',
        responseType: 'arraybuffer',
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `${filename}.csv`);
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },

    importEmployees: function () {
      this.eventHub.$emit('importFileDialog', { status: true });
    },

    importGovernment: function () {
      this.eventHub.$emit('importGovDialog', { status: true });
    },

    importBasicSalary: function () {
      console.log('test dialog')
      this.eventHub.$emit('bsDialog', { status: true });
    },

    changeStatus: function (status, obj) {
      this.eventHub.$emit('changeEmpStatus', { status: status, emp: obj });
    },

    getDropdownProperties: function () {
      axios.create({
        baseURL: this.apiUrl,
        headers: { 'Authorization': `Bearer ${this.token}` }
      }).get('/employee/dropdown/properties')
        .then((res) => {
          this.paymentmode = res.data.data.paymentMode
          this.payingbank = res.data.data.bank
          this.payclass = res.data.data.payClass
          this.gender = res.data.data.gender
          this.locationOptions = res.data.data.location
          this.locationOptions.unshift('ALL')
          this.statuses = res.data.data.status
          this.statuses.unshift('ALL')
          this.departments = res.data.data.department
          this.departments.unshift({ 'id': 0, 'name': 'ALL' })
        });
    },

    autoCareerUpdate: function () {
      axios.create({
        baseURL: this.apiUrl,
        headers: { 'Authorization': `Bearer ${this.token}` }
      }).get('/employee/check/careerupdate')
        .then((res) => {
          console.log(res.data.msg)
        });
    },

    autoHoldEmployee: function () {
      axios.create({
        baseURL: this.apiUrl,
        headers: { 'Authorization': `Bearer ${this.token}` }
      }).get('/employee/hold/status')
        .then((res) => {
          console.log(res.data.message)
        });
    },

    autoActivateEmployee: function () {
      axios.create({
        baseURL: this.apiUrl,
        headers: { 'Authorization': `Bearer ${this.token}` }
      }).get('/employee/activate/status')
        .then((res) => {
          console.log(res.data.message)
        });
    },

    downloadModal: function () {
      this.eventHub.$emit('FilterOptions', { status: true });
    },

    // ================================================
    // Schedule CRUD Operations
    // ================================================
    editSchedule(employee, day) {
      this.selectedEmployee = employee;
      this.selectedDay = day;
      const existingTime = employee[day];
      
      if (existingTime) {
        // Parse existing time format "HH:mm - HH:mm" or "H:mm AM/PM - H:mm AM/PM"
        const times = existingTime.split(' - ');
        if (times.length === 2) {
          this.scheduleForm.startTime = this.convertTo24HourFormat(times[0].trim());
          this.scheduleForm.endTime = this.convertTo24HourFormat(times[1].trim());
        }
      } else {
        this.scheduleForm.startTime = null;
        this.scheduleForm.endTime = null;
      }
      
      this.scheduleDialog = true;
    },

    convertTo24HourFormat(timeStr) {
      // Convert "H:mm AM/PM" to "HH:mm" format for q-time
      const time12hr = timeStr.trim();
      const [time, period] = time12hr.split(' ');
      let [hours, minutes] = time.split(':');
      
      hours = parseInt(hours);
      
      if (period === 'AM' || period === 'am') {
        if (hours === 12) hours = 0;
      } else if (period === 'PM' || period === 'pm') {
        if (hours !== 12) hours += 12;
      }
      
      return `${String(hours).padStart(2, '0')}:${minutes}`;
    },

    convertTo12HourFormat(time24hr) {
      // Convert "HH:mm" to "H:mm AM/PM" format for display
      const [hours, minutes] = time24hr.split(':');
      let hour = parseInt(hours);
      const period = hour >= 12 ? 'PM' : 'AM';
      
      if (hour > 12) hour -= 12;
      if (hour === 0) hour = 12;
      
      return `${hour}:${minutes} ${period}`;
    },

    saveSchedule() {
      if (!this.scheduleForm.startTime || !this.scheduleForm.endTime) {
        this.$q.notify({
          message: 'Please select both start and end times',
          color: 'warning',
          position: 'center',
        });
        return;
      }
      this.disableButton = true;
      const startTime12 = this.convertTo12HourFormat(this.scheduleForm.startTime);
      const endTime12 = this.convertTo12HourFormat(this.scheduleForm.endTime);
      const shiftTime = `${startTime12} - ${endTime12}`;

      const payload = {
        employee_id: this.selectedEmployee.id,
        day: this.selectedDay,
        shift_time: shiftTime,
        start_time: this.scheduleForm.startTime,
        end_time: this.scheduleForm.endTime,
      };

      // Check if schedule exists (for update vs create)
      const isUpdate = this.selectedEmployee[this.selectedDay];

      const endpoint = isUpdate 
        ? `/employee/schedule/update` 
        : `/employee/schedule/create`;
      const method = isUpdate ? 'put' : 'post';

      axios({
        method: method,
        url: this.apiUrl + endpoint,
        headers: { 
          'Authorization': `Bearer ${this.token}`,
          'Content-Type': 'application/json'
        },
        data: payload
      }).then((response) => {
        if (response.data.status) {
          this.$set(this.selectedEmployee, this.selectedDay, shiftTime);
          this.$q.notify({
            message: 'Schedule saved successfully',
            color: 'green',
            position: 'center',
          });
          this.scheduleDialog = false;
          this.disableButton = false;
        } else {
          this.$q.notify({
            message: response.data.message || 'Error saving schedule',
            color: 'negative',
            position: 'center',
          });
        }
      }).catch((error) => {
        console.error('Error:', error);
        this.$q.notify({
          message: error.response?.data?.message || error.message || 'Error saving schedule',
          color: 'negative',
          position: 'center',
        });
      });
    },

    deleteSchedule() {
      this.$q.dialog({
        title: 'Delete Schedule',
        message: 'Are you sure you want to delete this schedule?',
        cancel: true,
        persistent: true
      }).onOk(() => {
        axios({
          method: 'delete',
          url: this.apiUrl + `/employee/schedule/delete`,
          headers: { 
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json'
          },
          data: {
            employee_id: this.selectedEmployee.id,
            day: this.selectedDay,
          }
        }).then((response) => {
          if (response.data.status) {
            this.$set(this.selectedEmployee, this.selectedDay, null);
            this.$q.notify({
              message: 'Schedule deleted successfully',
              color: 'green',
              position: 'center',
            });
            this.scheduleDialog = false;
          } else {
            this.$q.notify({
              message: response.data.message || 'Error deleting schedule',
              color: 'negative',
              position: 'center',
            });
          }
        }).catch((error) => {
          console.error('Error:', error);
          this.$q.notify({
            message: error.response?.data?.message || error.message || 'Error deleting schedule',
            color: 'negative',
            position: 'center',
          });
        });
      });
    },

    closeScheduleDialog() {
      this.scheduleDialog = false;
      this.scheduleForm = { shiftTime: '', startTime: null, endTime: null };
    },

    getMyPermission: function () {
      //console.log(this.userData.id)
      axios.create({
        baseURL: this.apiUrl,
        headers: { 'Authorization': `Bearer ${this.token}` }
      }).get(`/admin/role/access/${this.userData.id}`)
        .then((res) => {
          var access = res.data.userAccess.moduleAction_id.split(",").map(Number)

          var dlResult = access.includes(this.canDownloadValue);
          if (dlResult) {
            this.canDownload = true
          } else {
            this.canDownload = false
          }

          var imResult = access.includes(this.canImportValue);
          if (imResult) {
            this.canImport = true
          } else {
            this.canImport = false
          }

          var exResult = access.includes(this.canEmportValue);
          if (exResult) {
            this.canExport = true
          } else {
            this.canExport = false
          }

          var edResult = access.includes(this.canEditValue);
          if (edResult) {
            this.canEdit = true
          } else {
            this.canEdit = false
          }

          var cuResult = access.includes(this.canUpdateCareerValue);
          if (cuResult) {
            this.canUpdateCareer = true
          } else {
            this.canUpdateCareer = false
          }

          var mbfResult = access.includes(this.canMBFValue);
          if (mbfResult) {
            this.canMBF = true
          } else {
            this.canMBF = false
          }

          var meritsResult = access.includes(this.canMBFValue);
          if (meritsResult) {
            this.canMerits = true
          } else {
            this.canMerits = false
          }

        });
    }
  }
}
</script>
<style lang="css" scoped></style>
